import React, { useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import api from 'api';
import util from 'utils/utils';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from 'actions';
import toast from 'react-hot-toast';

import TagModalChooser from 'components/lib/Choosers/Tags/TagModalChooser';

const IdeaTags = ({
  user, challenge, updateIdea, idea, updateTagList, isSubmission = false,
}) => {
  const currentChallenge = challenge || idea.ownerChallenge;
  const canEdit = useMemo(() => util.canEditIdea(user, idea) || util.canManageChallenge(user, currentChallenge), [user, idea, currentChallenge]);

  const updateTagListWithTag = useCallback((tag) => {
    const tagList = [...currentChallenge.tagList];
    const index = tagList.findIndex((t) => t._id === tag._id);
    tagList[index] = tag;

    if (challenge) {
      updateTagList(challenge._id, tagList);
    } else {
      updateIdea({ ...currentChallenge, tagList }, ['ownerChallenge'], true);
    }
  }, [updateTagList, updateIdea, currentChallenge, challenge]);

  const addTag = useCallback((tag) => {
    api.tags.tagSingle('ideas', tag._id, idea._id, (updatedTag) => {
      const fullTags = [...idea.fullTags];
      fullTags.push(updatedTag);
      updateIdea(fullTags, ['fullTags'], true);
      updateIdea(fullTags.map((t) => t._id), ['tags'], true);
      updateTagListWithTag(updatedTag);
    }, (err) => toast.error(err.message));
  }, [idea, updateIdea, updateTagListWithTag]);

  const removeTag = useCallback((tag) => {
    api.tags.untagSingle('ideas', tag._id, idea._id, (updatedTag) => {
      const fullTags = [...idea.fullTags];
      const cIndex = fullTags.findIndex((t) => t._id === updatedTag._id);
      fullTags.splice(cIndex, 1);
      updateIdea(fullTags, ['fullTags'], true);
      updateIdea(fullTags.map((t) => t._id), ['tags'], true);
      updateTagListWithTag(updatedTag);
    });
  }, [idea, updateIdea, updateTagListWithTag]);

  if (!currentChallenge) {
    return null;
  }

  return (
    <>
      <TagModalChooser
        trigger={!isSubmission && <Button compact circular icon='hashtag' content='Edit tags' size='tiny' style={{ marginLeft: 3 }} />}
        showTags
        tags={idea.fullTags}
        availableTags={currentChallenge.tagList}
        addTag={addTag}
        removeTag={removeTag}
        canEdit={canEdit}
      />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const challenge = state.challenges.challenges.filter((c) => c._id === ownProps.idea.challenge)[0];
  return { user: state.user, challenge };
};

const mapDispatchToProps = (dispatch) => ({
  updateTagList: (id, tagList) => dispatch(actions.challenges.update(id, { tagList })),
});

const IdeaTagsContainer = withTranslation()(connect(
  mapStateToProps, mapDispatchToProps,
)(IdeaTags));

export default withTranslation()(withRouter(IdeaTagsContainer));
